import { useContext, type PropsWithChildren } from "react";
import { useExperiment } from "@hopper-b2b/experiments";
import {
  KustomerChatSupportProvider,
  useKustomerConfig,
} from "@hopper-b2b/self-serve";
import { ClientName } from "@hopper-b2b/types";
import { EXPERIMENTS, UserContext } from "../../App";
import config from "../../utils/config";
import { NuchatProvider } from "../NuchatProvider";

export const NubankChatSupportProvider = ({ children }: PropsWithChildren) => {
  const { sessionInfo } = useContext(UserContext);

  const kustomerConfig = useKustomerConfig(ClientName.NUBANK, config);

  const nuchatEntrypoint = useExperiment(EXPERIMENTS.NUBANK_CHAT_ENTRYPOINT);

  // Check if support access is restricted
  const portalAccess = sessionInfo?.userInfoResponse?.portalAccess;
  const isSupportRestricted = portalAccess?.support === false;

  // If support is restricted, don't render the chat support provider
  if (isSupportRestricted) {
    return <>{children}</>;
  }

  return nuchatEntrypoint ? (
    <NuchatProvider>{children}</NuchatProvider>
  ) : (
    <KustomerChatSupportProvider
      config={{
        ...kustomerConfig,
        hopperUserId: sessionInfo?.hopperUserId,
        kustomerAccessToken: sessionInfo?.userInfoResponse.kustomerAccessToken,
        forceUserLanguage: "pt-BR",
      }}
    >
      {children}
    </KustomerChatSupportProvider>
  );
};
